export enum TargetTypes {
  CompanyGroup = 1,
  Location = 2,
  User = 3
}
